export const STUDENT_INFO = "/student-info-sb/v0";
export const STUDENT_INFO_STUDENT = `${STUDENT_INFO}/student`;
// Currently enrolled students; includes address/school for the search detail panel.
export const STUDENT_INFO_BY_STUDENT_NUMBER = `${STUDENT_INFO_STUDENT}/active`; // /{studentNumber}/detail.json
// Includes inactive students; used when active returns 400/404 (no current enrollment).
export const STUDENT_INFO_BASIC_BY_STUDENT_NUMBER = `${STUDENT_INFO_STUDENT}/basic`; // /{studentNumber}/detail.json
export const STUDENTS_BY_GUARDIAN_GET = `${STUDENT_INFO}/guardian/students`; // /{userName}/index.json
